import fetch from 'isomorphic-fetch'
import _ from 'lodash'
import log from 'blazar-sentry'
import { createAction } from 'redux-actions'

import { actionCreators as authenticationActionCreators } from '@blocket/authentication-fe'
import { LOGOUT } from 'external/reduxBits/authentication/actions'
import isBrowser from 'utils/isBrowser'

import handleApiResponse from './handleApiResponse'

const MAX_RETRIES = 1

export const apiFetch = (url, params = {}, retryCount = 0) => async (dispatch, getState) => {
  let response

  try {
    response = await fetch(url, {
      ...params,
      headers: {
        Authorization: `Bearer ${getState().authentication.bearerToken}`,
        ...params.headers,
      },
    })
  } catch (error) {
    /* eslint-disable no-console */
    if (process.env.NODE_ENV === 'development') {
      console.warn(`fetching ${url} failed, retrying once: ${error}`)
    }

    try {
      response = await fetch(url, {
        ...params,
        headers: {
          ...params.headers,
          Authorization: `Bearer ${getState().authentication.bearerToken}`,
        },
      })
    } catch (retryError) {
      if (process.env.NODE_ENV === 'development') {
        console.error(`fetching ${url} failed again: ${retryError.message}`, retryError)
      }
      retryError.ok = false
      retryError.status = 500
      retryError.url = url
      return retryError
    }
  }

  if (response.status === 401 && retryCount < MAX_RETRIES) {
    if (getState().authentication.loggedIn && isBrowser()) {
      log.warn('spid bearer token is invalid while logged in.')
      dispatch(createAction(LOGOUT)())
    }

    // Retry the fetch with a fresh apiKey bearerToken.
    await dispatch(authenticationActionCreators.authentication.fetchBearerToken('apiKey'))

    return dispatch(apiFetch(url, params, retryCount + 1))
  }

  return handleApiResponse(response)
}

const amokApiFetch = (path, params) => (dispatch, getState) =>
  dispatch(apiFetch(`${getState().config.urls.api}/${path}`, params))

const templateApiFetch = (path, params) => (dispatch, getState) =>
  dispatch(apiFetch(`${getState().config.urls.api}/blocket/v7/template_proxy/${path}`, params))

const legacyApiFetch = (path, params) => (dispatch, getState) =>
  dispatch(
    apiFetch(
      `${getState().config.urls.api}/${path}`,
      _.merge({}, params, { headers: { 'X-Accept-Charset': 'utf-8' } }),
    ),
  )

export const actionCreators = {
  fetch: amokApiFetch,
  legacyApiFetch,
  templateApiFetch,
}
